/*
 * Custom code to get the marketing cookie content target based on the manifest and allowed cookies.
 * This utility function is used to filter the cookies that are sent to the eSpot API based on the manifest configuration and any additional allowed cookies or prefixes.
 * It checks the manifest for the list of cookie targets, and if "ALL" is specified, it returns all cookies. Otherwise, it picks only the cookies that are specified in the manifest or allowed lists.
 */
import { ALL_COOKIES } from '@/data/constants/marketingCookieContentTarget';
import { dataMarketingCookieContentTargetManifest } from '@/data/MarketingCookieContentTarget/manifest';
import entries from 'lodash/entries';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';

const EMPTY_TARGETS = {};

const getMarketingCookieContentTargetsListFromManifest = () => {
	if (dataMarketingCookieContentTargetManifest.ALL) {
		return [ALL_COOKIES];
	} else {
		return entries(dataMarketingCookieContentTargetManifest)
			.filter(([_, value]) => value)
			.map(([target]) => target);
	}
};

export const getMarketingCookieContentTarget = ({
	cookies,
	allowedCookies,
	allowedPrefixed,
}: {
	cookies: Partial<{
		[key: string]: string;
	}>;
	allowedCookies?: string[];
	allowedPrefixed?: string[];
}) => {
	const allowedPrefix = Object.keys(cookies).filter((key) =>
		allowedPrefixed?.some((prefix) => key.startsWith(prefix))
	);
	const cookieTargets = [
		...getMarketingCookieContentTargetsListFromManifest(),
		...(allowedCookies ?? []),
		...(allowedPrefix ?? []),
	];
	return isEmpty(cookieTargets)
		? EMPTY_TARGETS
		: cookieTargets.at(0) === ALL_COOKIES
		? cookies
		: pick(cookies, cookieTargets);
};
